(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const scopedCollection = document.querySelector('[data-collection-category-scope]');
  if (scopedCollection) {
    const filterUrl = new URL(window.location.href);
    const categoryScope = scopedCollection.dataset.collectionCategoryScope;
    const categoryParam = 'filter.p.m.custom.shop_categories';
    let selectionChanged = false;
    if (categoryScope !== '*') {
      const allowedCategories = categoryScope === '-' ? [] : categoryScope.split('|');
      const selectedCategories = filterUrl.searchParams.getAll(categoryParam).flatMap(value => value.split(','));
      const permittedCategories = selectedCategories.filter(value => allowedCategories.includes(value));
      if (permittedCategories.length !== selectedCategories.length) {
        filterUrl.searchParams.delete(categoryParam);
        permittedCategories.forEach(value => filterUrl.searchParams.append(categoryParam, value));
        selectionChanged = true;
      }
      if (filterUrl.searchParams.has('filter.p.product_type')) {
        filterUrl.searchParams.delete('filter.p.product_type');
        selectionChanged = true;
      }
    }
    if (scopedCollection.dataset.collectionCaliberEnabled === 'false' && filterUrl.searchParams.has('filter.p.m.custom.magazine_type')) {
      filterUrl.searchParams.delete('filter.p.m.custom.magazine_type');
      selectionChanged = true;
    }
    if (selectionChanged) {
      filterUrl.searchParams.delete('page');
      window.location.replace(filterUrl.href);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
